const LangEnum = {
	vi: 'Tiếng việt',
	en: 'Tiếng anh',
};

export default LangEnum;
